/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Nav from 'ember-power-calendar/components/power-calendar/nav';
import moment from 'moment-timezone';

import { action } from '@ember/object';

import type { PowerCalendarAPI } from 'ember-power-calendar/components/power-calendar';
import type { Select } from 'ember-power-select/components/power-select';

export default class BvCalendarNavComponent extends Nav {
  get months() {
    return moment.months();
  }

  get years() {
    const nbYears = 10;
    const years = [];
    for (let i = -nbYears; i < nbYears * 2; i++) {
      years.push(`${i + moment.utc().year()}`);
    }
    return years;
  }

  @action
  changeCalCenter(
    unit: 'year' | 'month',
    calendar: PowerCalendarAPI,
    value: string,
    _select: Select,
    e: MouseEvent
  ) {
    const newCenter = moment.utc(calendar.center).clone()[unit](value) as moment.Moment;
    calendar.actions.changeCenter?.(newCenter.toDate(), calendar, e);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCalendar::Nav': typeof BvCalendarNavComponent;
    'bv-calendar/nav': typeof BvCalendarNavComponent;
  }
}
